export default __webpack_public_path__ + "static/media/34g.66e1f18b.svg";